import { render, staticRenderFns } from "./VisitAttempts.vue?vue&type=template&id=2fef5d86"
import script from "./VisitAttempts.vue?vue&type=script&lang=js"
export * from "./VisitAttempts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports